import querystring from 'query-string';

import { gameRunningStatuses } from 'config/gameRunningStatuses';
import { searchTypes } from 'ugc/components/workPage/SettingPreviews/defaultGameSetting';
import { SortTypeMapping } from 'ugc/components/workPage/SettingPreviews/defaultGameSetting';

export default function getUgcRelatedState(state, isContestUgcModule) {
    const {
        promoState: { gameRunningStatus }
    } = state;
    const {
        settingGame: {
            enableUgcAuthorNameInput,
            enableImageTitleInput,
            enableUgcTitleInput,
            ugcGameSetting: {
                headerFunctionSettings: { defaultSortType = SortTypeMapping.TIME } = {}
            } = {}
        }
    } = isContestUgcModule ? state.relatedTwinsPromo : state;
    let searchTypeOptions = [];
    if (Boolean(enableUgcAuthorNameInput)) {
        searchTypeOptions.push(searchTypes.AUTHOR_NAME);
    }
    if (Boolean(enableImageTitleInput) || Boolean(enableUgcTitleInput)) {
        searchTypeOptions.push(searchTypes.PORTFOLIO_NAME);
    }
    const { page = 1 } = querystring.parse(window.location.search);
    const showRankingTab =
        isContestUgcModule &&
        gameRunningStatus !== gameRunningStatuses.NOT_PUBLISH &&
        gameRunningStatus !== gameRunningStatuses.BEFORE;
    const sortingType = (() => {
        if (defaultSortType === SortTypeMapping.RANKING) {
            return showRankingTab ? SortTypeMapping.RANKING : SortTypeMapping.TIME;
        } else {
            return defaultSortType;
        }
    })();

    return {
        flagsUgc: {
            searchTypeOptions,
            searchType: searchTypeOptions[0] ?? searchTypes.NO_SEARCH,
            sortingType
        },
        ugcCollections: {
            page: Number(page)
        }
    };
}
